module.exports = {"package":"content","businessUnit":"tryg","setup":"tf-ou"}


//////////////////
// WEBPACK FOOTER
// ./src/env.json
// module id = 629
// module chunks = 0